var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content Tabs"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":_vm.lang.tab_Parts,"title-link-class":_vm.textColors,"title-item-class":_vm.textColors,"active":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d1aa58c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartManager/Views/UL/Middle/Content/Content.vue
// module id = null
// module chunks = 